// @ts-nocheck
import React, { memo } from 'react';
import { Card, CardHeader, CardBody } from '@components/card/card.jsx';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { usePermissions } from '../../../../../Helper/Permisstions/usePermissions';

const CardEmployees = ({ Employees }) => {
  const { HasPermission } = usePermissions();
  const { t, i18n } = useTranslation();

  // دالة لتوليد لون عشوائي للشارة بناء على نص معين
  const generateBadgeColor = text => {
    const colors = [
      'linear-gradient(135deg, #6a11cb 0%, #2575fc 100%)',
      'linear-gradient(135deg, #FF512F 0%, #DD2476 100%)',
      'linear-gradient(135deg, #f46b45 0%, #eea849 100%)',
      'linear-gradient(135deg, #11998e 0%, #38ef7d 100%)',
      'linear-gradient(135deg, #c471f5 0%, #fa71cd 100%)',
      'linear-gradient(135deg, #5D4157 0%, #A8CABA 100%)'
    ];
    let hash = 0;
    for (let i = 0; i < text?.length; i++) {
      hash = text.charCodeAt(i) + ((hash << 5) - hash);
    }
    return colors[Math.abs(hash) % colors?.length];
  };

  return (
    <>
      <div className='row g-4'>
        {Employees?.map(item => {
          const isTerminated = item.endOfServiceDate !== null;
          const isNotAssigned = item.organizatioN_ID === null;
          const orgName = i18n.language === 'ar' ? item.organizatioN_NAME2 : item.organizatioN_NAME;
          const jobName = i18n.language === 'ar' ? item.jobName2 : item.jobName;
          const employeeName = i18n.language === 'en' ? item.name : item.name2;

          return (
            <div className='col-xl-4 col-lg-6 col-md-6 col-sm-12' key={item.id}>
              <Card className='card-employee h-100'>
                <CardHeader className='d-flex justify-content-between align-items-center pb-2'>
                  <div className='employee-title'>
                    <div className='fw-bold text-truncate mb-1' title={employeeName}>
                      {employeeName}
                    </div>
                    <div
                      className='employee-number-badge'
                      style={{ background: generateBadgeColor(item.employeeNumber) }}
                    >
                      <i className='fas fa-id-badge me-1'></i>
                      {item.employeeNumber}
                    </div>
                  </div>

                  {isTerminated && (
                    <span className='badge bg-danger status-badge'>
                      <i className='fas fa-user-slash me-1'></i>
                      {t('Terminated')}
                    </span>
                  )}
                </CardHeader>

                <CardBody>
                  <div className='employee-content'>
                    {/* صورة الموظف */}
                    <div className='employee-image-container mb-3'>
                      <img
                        src={
                          item?.personImage?.filePath ||
                          (item.gender === 'M'
                            ? '../../../assets/img/user/manEmp.png'
                            : '../../../assets/img/user/WomanEmp.png')
                        }
                        alt={employeeName}
                        className='employee-image'
                        loading='lazy'
                        onError={e => {
                          e.target.onerror = null;
                          e.target.src =
                            item.gender === 'M'
                              ? '../../../assets/img/user/manEmp.png'
                              : '../../../assets/img/user/WomanEmp.png';
                        }}
                      />
                    </div>

                    {/* معلومات الهوية */}
                    <div className='employee-info mb-3'>
                      <div className='d-flex align-items-center mb-2'>
                        <i className='fas fa-fw fa-id-card text-theme me-2'></i>
                        <span>{item.nationalIdentifier}</span>
                      </div>
                    </div>

                    {/* معلومات الوظيفة والقسم */}
                    <div className='employee-job-info'>
                      {!isNotAssigned ? (
                        <>
                          <div className='d-flex align-items-center mb-2'>
                            <i className='fas fa-fw fa-building text-theme me-2'></i>
                            <span className='text-truncate' title={orgName}>
                              {orgName}
                            </span>
                          </div>
                          <div className='d-flex align-items-center'>
                            <i className='fas fa-fw fa-briefcase text-theme me-2'></i>
                            <span className='text-truncate' title={jobName}>
                              {jobName}
                            </span>
                          </div>
                        </>
                      ) : (
                        <div className='text-center'>
                          <span className='badge bg-warning'>{t('NotAssigned')}</span>
                        </div>
                      )}
                    </div>

                    {/* قائمة الخيارات */}
                    <div className='employee-actions mt-3 pt-3 border-top'>
                      <div className='dropdown'>
                        <button
                          className='btn btn-sm btn-outline-theme dropdown-toggle w-100'
                          type='button'
                          data-bs-toggle='dropdown'
                          aria-expanded='false'
                        >
                          <i className='fas fa-cog me-2'></i>
                          {t('Actions')}
                        </button>

                        <ul className='dropdown-menu dropdown-menu-start w-100 '>
                          {HasPermission('DetailsHrPerson') && (
                            <li>
                              <Link to={`${item.id}/Edit`} className='dropdown-item d-flex justify-content-start '>
                                <i className='fa fa-user fa-fw me-2 text-theme'></i>
                                {t('EmployeeDetails')}
                              </Link>
                            </li>
                          )}

                          {HasPermission('ExtraInformationHrPerson') && (
                            <li>
                              <Link
                                className='dropdown-item  d-flex justify-content-start '
                                to={`${item.id}/ExtraRecordFormPerson`}
                                onClick={() => localStorage.setItem('ReferenceName', JSON.stringify(item))}
                              >
                                <i className='fa fa-info-circle fa-fw me-2 text-theme'></i>
                                {t('extrarecord')}
                              </Link>
                            </li>
                          )}

                          {HasPermission('ViewdetailsHrPerAssignment') && (
                            <li>
                              <Link
                                to={`${item.id}/Assignments`}
                                className='dropdown-item  d-flex justify-content-start '
                              >
                                <i className='fa fa-clipboard-list fa-fw me-2 text-theme'></i>
                                {t('Assign')}
                              </Link>
                            </li>
                          )}

                          {HasPermission('ViewlistHrPerAbsence') && (
                            <li>
                              <Link
                                to={`AbsencesAndVacations/${item.id}`}
                                className='dropdown-item  d-flex justify-content-start '
                              >
                                <i className='fa fa-calendar-times fa-fw me-2 text-theme'></i>
                                {t('الإجازات')}
                              </Link>
                            </li>
                          )}
                          <li>
                            <Link to={`Contracts/${item.id}`} className='dropdown-item d-flex justify-content-start'>
                              <i className='fa fa-file-contract fa-fw me-2 text-theme'></i>
                              {t('Contracts')}
                            </Link>
                          </li>

                          {HasPermission('AddPeriodOfService') && (
                            <li>
                              <Link
                                className='dropdown-item  d-flex justify-content-start '
                                to={`EndOfService/${item.id}`}
                                state={{
                                  ReferenceName: employeeName
                                }}
                              >
                                <i className='fa fa-user-slash fa-fw me-2 text-theme'></i>
                                {t('EndOfService')}
                              </Link>
                            </li>
                          )}
                        </ul>
                      </div>
                    </div>
                  </div>
                </CardBody>
              </Card>
            </div>
          );
        })}
      </div>

      <style>
        {`
          .card-employee {
            transition: all 0.3s ease;
            border: 1px solid rgba(var(--bs-theme-rgb), 0.1);
            overflow: hidden;
            // border-radius: 12px;
          }
          
          .card-employee:hover {
            transform: translateY(-5px);
            box-shadow: 0 12px 25px rgba(0, 0, 0, 0.15);
            border-color: rgba(var(--bs-theme-rgb), 0.5);
          }
          
          .employee-image-container {
            display: flex;
            justify-content: center;
          }
          
          .employee-image {
            width: 120px;
            height: 120px;
            object-fit: cover;
            border-radius: 50%;
            border: 3px solid rgba(var(--bs-theme-rgb), 0.4);
            box-shadow: 0 4px 10px rgba(0, 0, 0, 0.2);
          }
          
          .employee-title {
            max-width: 70%;
          }
          
          .employee-info, .employee-job-info {
            font-size: 0.9rem;
          }
          
          .employee-actions .dropdown-toggle::after {
            margin-right: 0.5em;
            margin-left: 0;
          }
          
          .employee-number-badge {
            display: inline-flex;
            align-items: center;
            padding: 0.35em 0.65em;
            font-size: 0.75em;
            font-weight: 700;
            line-height: 1;
            color: white;
            text-align: center;
            white-space: nowrap;
            vertical-align: baseline;
            border-radius: 0.375rem;
            box-shadow: 0 2px 5px rgba(0, 0, 0, 0.2);
          }
          
          .status-badge {
            box-shadow: 0 2px 5px rgba(0, 0, 0, 0.2);
          }
          
          @media (max-width: 576px) {
            .employee-image {
              width: 100px;
              height: 100px;
            }
            
            .employee-number-badge {
              font-size: 0.7em;
              padding: 0.3em 0.6em;
            }
          }
        `}
      </style>
    </>
  );
};

export default memo(CardEmployees);
